import { environment } from "../../environments/environment.prod";

export const config = {
  url: environment.url,
  ms_booking: environment.ms_booking,
  ms_parking: environment.ms_parking,
  ms_transaction: environment.ms_transaction,
  XFrontendId: "caucana",
};
